import { DietIdEnum, DietModeType } from '@front-activerse/common-components';

export const DIET_TYPES = [
  {
    id: 2,
    value: DietIdEnum.DIET_ID_HIGH_PROTEIN,
    optionTitle: 'app.goalSettings.dietType.optionHighProtein.title',
    optionDescription: 'app.goalSettings.dietType.optionHighProtein.description',
    macro: {
      protein: '25',
      fat: '30',
      carbs: '45',
    },
  },
  {
    id: 1,
    value: DietIdEnum.DIET_ID_HIGH_PROTEIN_VEGE,
    optionTitle: 'app.goalSettings.dietType.optionHighProteinVege.title',
    optionDescription: 'app.goalSettings.dietType.optionHighProteinVege.description',
    macro: {
      protein: '22',
      fat: '30',
      carbs: '48',
    },
  },
];

export const DIET_MODES = [
  {
    value: DietModeType.slimming,
    optionTitle: 'app.goalSettings.goal.optionWeightLoss.title',
    optionDescription: 'app.goalSettings.goal.optionWeightLoss.description',
  },
  {
    value: DietModeType.stabilization,
    optionTitle: 'app.goalSettings.goal.optionWeightMaintain.title',
    optionDescription: 'app.goalSettings.goal.optionWeightMaintain.description',
  },
  {
    value: DietModeType.gain_muscle_mass,
    optionTitle: 'app.goalSettings.goal.optionBuildMuscle.title',
    optionDescription: 'app.goalSettings.goal.optionBuildMuscle.description',
  },
];

// for i18n-unused
// t('app.goalSettings.dietType.optionClassic.title')
// t('app.goalSettings.dietType.optionClassic.description')
// t('app.goalSettings.dietType.optionVeggie.title')
// t('app.goalSettings.dietType.optionVeggie.description')
// t('app.goalSettings.dietType.optionVegan.title')
// t('app.goalSettings.dietType.optionVegan.description')
// t('app.goalSettings.dietType.optionHighProtein.title')
// t('app.goalSettings.dietType.optionHighProtein.description')
// t('app.goalSettings.dietType.optionGLP1.title')
// t('app.goalSettings.dietType.optionGLP1.description')

// t('app.goalSettings.goal.optionWeightLoss.title')
// t('app.goalSettings.goal.optionWeightLoss.description')
// t('app.goalSettings.goal.optionWeightMaintain.title')
// t('app.goalSettings.goal.optionWeightMaintain.description')
// t('app.goalSettings.goal.optionBuildMuscle.title')
// t('app.goalSettings.goal.optionBuildMuscle.description')
